import { Fragment, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import navdots from '../../../Assets/images/navdots.svg';
import TrainingStatusModal from "../RequestorManagement/TrainingStatusModal";
import ConfirmationModal from "../../ConfirmationModal";
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { getStatusLabel, getLabStatusLabel, SampleRequestService } from "../../../Services/SampleRequest.Service";
import PickupDetailsModal from "./PickupDetailsModal";
import CancellationNoteModal from "./CancellationNoteModal";
import { useMediaQuery } from "react-responsive";
import { FaCircle, FaPencilAlt, FaCheck } from "react-icons/fa";
import TokenService from "../../../Services/Token.service";

function SampleTypeTableRow({ sampleType, handleCancelRequest, handleDeleteRequest, handleDuplicateRequest,handlePickupDetailsUpdateModal,fetchDonorList, sampleTypes, type }) {
    
    const navigate = useNavigate();
    const userRestrictions = TokenService.getUserRestrictions() || [];
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [id, setId] = useState(sampleType.id);
    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmCancelRequest = (cancellationNote) => {
        handleCancelRequest(sampleType, cancellationNote);
        handleCloseDeactivateModal();
    };


    const [showPickupModal, setShowPickupModal] = useState(false);
    const handleShowPickupModal = () => setShowPickupModal(true);
    const handleClosePickupModal = () => setShowPickupModal(false);
  
    const confirmPickupModal = (values) => {
         
        handlePickupDetailsUpdateModal(sampleType.id, values);  
        handleClosePickupModal();
    };
    
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = () => {
        handleDeleteRequest(sampleType.id );
        handleCloseDeleteModal();
    };


    const sampleIds = sampleType.sample_ids ? sampleType.sample_ids?.split(',').map(id => id.trim()) : [];

    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <>
        {isMobile ? (
            <div className="admin-card-list">
           
              <div className="admin-card el-bg-table mb-2" >
 
                <div className="card-header">
 
                <div className="card-actions" style={{height:'10px'}}>
                 <div style={{float:'right'}}>
                 <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="el-action">
                                {/* onClick={handleEditDonor}  */}

                                {(sampleType.status != 0) && (
                                    <> 
                                        <Dropdown.Item
                                            as={Link} to={`viewdetails`} state={{ sampleType, type,  id } }
                                        >
                                            <label>View Details</label>
                                        </Dropdown.Item>

                                    </>
                                )}

                                
                                    {type !== 'requestor'  && (sampleType.status !== 4 ) &&  (     // no requestor and no status cancelled
                                        <Dropdown.Item   as={Link} to={`collectsamples`} state={{ sampleType, type,  id , isCollectSample : true} }  >
                                            <label>Collect Samples</label>
                                        </Dropdown.Item>

                                    )}
                                    {(type !== 'requestor' && (sampleType.status === 7 || sampleType.status === 8)) && (
                                        <Dropdown.Item
                                            data-bs-toggle="modal"
                                            data-bs-target="#markpickedup"
                                            onClick={handleShowPickupModal}
                                        >
                                            Mark Picked Up
                                        </Dropdown.Item>
                                    )}
                                    {/* onClick={() => handleChangeStatus(donor, donor.active)} */}

                                    {!userRestrictions.includes('request-new-sample') && (
                                        <>
                                            {(type == 'requestor' && sampleType.status == 0) && (
                                                <>
                                                {/* as={Link} to={`viewdetails`} state={{ sampleType, type,  id } } */}
                                                    <Dropdown.Item  as={Link} to={`/requestor/request-new-sample`} state={{id} }   >
                                                        <label >{'Edit'}</label>
                                                    </Dropdown.Item> </>
                                            )}

                                            {/* && sampleType.status !== 5 */}
                                            {(type == 'requestor' ) && (
                                                <>
                                                    <Dropdown.Item onClick={()=> handleDuplicateRequest(sampleType.id )}  >
                                                        <label >{'Duplicate'}</label>
                                                    </Dropdown.Item> </>
                                            )}
                                        </>
                                    )}

                                    {(type == 'requestor' && sampleType.status == 0) && (
                                        <>
                                            <Dropdown.Item  onClick={handleShowDeleteModal}>
                                                <label >{'Delete'}</label>
                                            </Dropdown.Item> </>
                                    )}
                                    {/* {
                                        //  (sampleType.status != 8  || sampleType.status != 9 || sampleType.status != 5 ) 
                                        (sampleType.status != 7  || sampleType.status != 8 || sampleType.status != 4 || sampleType.status != 0) 
                                        && (<Dropdown.Item onClick={handleShowDeactivateModal}>
                                                <label className={`text-danger`}>{'Cancel Request'}</label>
                                            </Dropdown.Item>) } */}
                                    {![7, 8, 4, 0].includes(sampleType.status) && (
                                        <Dropdown.Item onClick={handleShowDeactivateModal}>
                                            <label className="text-danger">{'Cancel Request'}</label>
                                        </Dropdown.Item>
                                    )}
                                    
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                 </div>
                  {/* <button className="btn btn-primary">View Details</button>
                  <button className="btn btn-warning" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Deactivate
                  </button>
                  <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#deleteuser">
                    Delete
                  </button> */}
                </div>
 
 
                
                </div>
                 
                    <div className={"card-body "} >

                        <p>  {type === 'requestor' && (
                            <>
                                <strong>Lab Status: </strong>
                                {/* <div className={donor.active ? "el-active" : "el-inactive"}>
                        <div className={donor.active ? "el-activebtn" : "el-inactive"}></div>
                        {donor.active ? "Active" : "Inactive"}
                    </div> */}
                                {getLabStatusLabel(sampleType.lab_status)}
                            </>
                        )}</p>
                        <p><strong>Status:</strong>                     {type === 'requestor' ? (
                            <>
                                {/* {sampleType.status} */}
                                <span className={`${sampleType.status == 4 ? 'text-danger' : ""}`}> {sampleType.status === 5 || sampleType.status === 6 || sampleType.status === 7 ? 'Submitted' : sampleType.status === 8 ? 'Completed' : getStatusLabel(sampleType.status, type)}</span>
                            </>
                        ) : (<>
                            <span className={`${sampleType.status == 4 ? 'text-danger' : ""}`}> {getStatusLabel(sampleType.status, type)}</span>
                        </>)
                        }</p>

                        
                        <p><strong> {type == 'requestor' ? "Job #" : "Job Id"} :</strong> {sampleType.job_id}</p>
                        <p><strong>Sample Type:</strong>    <div className="el-icons-bg-box">
                            {sampleIds.length > 0 ? (
                                sampleIds.map((sampleId) => {
                                    const sampleType = sampleTypes.find((type) => type.id === sampleId);
                                    return sampleType ? ( 
                                        <Fragment key={sampleId}>
                                            {sampleIds.length == 1 ? (<><div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div> </>) : (<><OverlayTrigger
                                                key={sampleId}
                                                placement="top"
                                                overlay={
                                                    <Popover id={`popover-${sampleId}`}>
                                                        <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                                    </Popover>
                                                }
                                            >
                                                {/* {sampleIds.length == 1 ? (<div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div>) :  ( */}
                                                <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                                    <i className={sampleType.className}></i>
                                                </Button>
                                                {/* )}  */}
                                            </OverlayTrigger>
                                            </>)} 
                                        </Fragment>
                                    ) : null;
                                })
                            ) : (
                                "No samples available"
                            )}
                        </div></p>

                        <p><strong>{type == 'requestor' ? "Collection Date" : "Due Date"} </strong>  {new Date(sampleType.sample_pickup_date).getTime() === 0
                            ? "-"
                            : new Date(sampleType.sample_pickup_date).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            })}</p>

                        {type !== 'requestor' && (
                            <p><strong>Requestor Name:</strong> {sampleType.requestor_name}</p>  
                        )}

                        <p><strong>Project Name:</strong>  {sampleType.project_name}</p>
                        <p><strong>{type == 'requestor' ? " #of Volunteers" : "Donors"}:</strong>  {sampleType.total_donors
                            ?
                            `${sampleType.appointments}/${sampleType.total_donors}`
                            : 'Data unavailable'}</p> 
                    </div> 
                </div> 
            </div>
          ):(<>
            <tr>    
                {/* //lab status removed */}
                 {/* className={`div-no-data`} */}
                {/* <td>{donor.first_name} {donor.middle_name} {donor.last_name}</td> */}
                {/* {type === 'requestor' && (
                    <td> */}
                        {/* <div className={donor.active ? "el-active" : "el-inactive"}>
                        <div className={donor.active ? "el-activebtn" : "el-inactive"}></div>
                        {donor.active ? "Active" : "Inactive"}
                    </div> */}
                       {/* <span className={`${sampleType.status == 4 ? 'text-danger': ''}`}> {getLabStatusLabel(sampleType.lab_status)} </span>
                    </td>
                )} */}
                <td >
                    {/* <div className={donor.active ? "el-active" : "el-inactive"}>
                        <div className={donor.active ? "el-activebtn" : "el-inactive"}></div>
                        {donor.active ? "Active" : "Inactive"}
                    </div> */}
                    {/* {getStatusLabel(donor.status)} */}
                    {type === 'requestor' ?  (
                        <>
                        {/* {sampleType.status} */}
                    {/* <span className={`${sampleType.status == 4 ? 'text-danger': sampleType.status == 0 ? "text-warning" :  sampleType.status == 5  || sampleType.status === 6 || sampleType.status === 7 ? "text-success" : ""}`}> 
                    {sampleType.status === 5 || sampleType.status === 6 || sampleType.status === 7 ? 'Submitted': sampleType.status === 8 ?'Completed' :  getStatusLabel(sampleType.status, type)}</span> */}

                    <span className={`d-flex align-items-center ${sampleType.status == 4 ? 'text-danger': sampleType.status == 0 ? "text-warning" :   sampleType.status == 1 || sampleType.status == 5  || sampleType.status === 6 || sampleType.status === 7  ? "li-sl-blue"  : sampleType.status === 8  ? "text-success" : ""}`}>
                    {sampleType.status === 0 && <FaPencilAlt className="me-2" />}
                    {sampleType.status === 8 && <i className="el-icon-check"></i> }                 {/* <FaCheck className="me-2" /> */}
   
                    {(  sampleType.status == 1 || sampleType.status === 5 || sampleType.status === 6 || sampleType.status === 7) && <FaCircle className=" fa-dot me-2 mb-1" />}
                    { sampleType.status === 1 || sampleType.status === 5 || sampleType.status === 6 || sampleType.status === 7
                        // ? 'Submitted'
                        ? 'Scheduled'
                        : sampleType.status === 8
                        ? 'Completed'
                        : getStatusLabel(sampleType.status, type)}
                    </span>
                        </>
                ) : (<> 
                    <span className={`${sampleType.status == 4 ? 'text-danger': ""}`}> {getStatusLabel(sampleType.status, type)}</span>
                    </>)
                }
                </td>
                <td>{sampleType.job_id}</td>
                {/* <td>
                    {donor.gender == 'XY' ? "Male (XY)" : "Female (XX)"}
                </td> */}


                <td className="">
                <div className="el-icons-bg-box">
                    {sampleIds.length > 0 ? (
                        sampleIds.map((sampleId) => {
                            const sampleType = sampleTypes.find((type) => type.id === sampleId);
                            return sampleType ? (
                                // <OverlayTrigger
                                //     key={sampleId}
                                //     placement="top"
                                //     overlay={
                                //         <Popover id={`popover-${sampleId}`}>
                                //             <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                //         </Popover>
                                //     }
                                // >
                                //     {/* <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                //         <i className={sampleType.className}></i>
                                //     </Button> */}
                                //     {sampleIds.length == 1 ? (<div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div>) : (<Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                //         <i className={sampleType.className}></i>
                                //     </Button>)}
                                // </OverlayTrigger>
                                <Fragment key={sampleId}>
                                {sampleIds.length == 1 ? (<><div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div> </>) : (<><OverlayTrigger
                                    key={sampleId}
                                    placement="top"
                                    overlay={
                                        <Popover id={`popover-${sampleId}`}>
                                            <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                        </Popover>
                                    }
                                >
                                    {/* {sampleIds.length == 1 ? (<div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div>) :  ( */}
                                    <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                        <i className={sampleType.className}></i>
                                    </Button>
                                    {/* )}  */}
                                </OverlayTrigger>
                                </>)}


                            </Fragment>
                            ) : null;
                        })
                    ) : (
                        "No samples available"
                    )}
                    </div>
                </td>
                {/* <td>
                    {new Date(sampleType.sample_pickup_date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                    })}
                </td> */}
                <td>
                {new Date(sampleType.sample_pickup_date).getTime() === 0
                    ? "-"
                    : new Date(sampleType.sample_pickup_date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    })}
                </td>

                {type !== 'requestor' && (
                    <td>
                        {sampleType.requestor_name}
                    </td>

                )}
                <td>
                    {sampleType.project_name}
                </td>
                <td>
                    { 
                    `${sampleType.appointments}/${sampleType.total_donors}`
                    }
                </td>

                <td>
                    <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="el-action" renderOnMount={true} 
                            popperConfig={{
                                strategy: "fixed"
                            }}>
                                {/* onClick={handleEditDonor}  */}

                                {(sampleType.status != 0) && (
                                    <> 
                                        <Dropdown.Item
                                            as={Link} to={`viewdetails`} state={{ sampleType, type,  id } }
                                        >
                                            <label>View Details</label>
                                        </Dropdown.Item>

                                    </>
                                )}

                                
                                    {type !== 'requestor'  && (sampleType.status !== 4 ) &&  (     // no requestor and no status cancelled
                                        <Dropdown.Item   as={Link} to={`collectsamples`} state={{ sampleType, type,  id , isCollectSample : true} } >
                                            <label>Collect Samples</label>
                                        </Dropdown.Item>

                                    )}
                                    {(type !== 'requestor' && (sampleType.status === 7 || sampleType.status === 8)) && (
                                        <Dropdown.Item
                                            data-bs-toggle="modal"
                                            data-bs-target="#markpickedup"
                                            onClick={handleShowPickupModal}
                                        >
                                            Mark Picked Up
                                        </Dropdown.Item>
                                    )}
                                    {/* onClick={() => handleChangeStatus(donor, donor.active)} */}

                                    {!userRestrictions.includes('request-new-sample') && (
                                        <>
                                            {(type == 'requestor' && sampleType.status == 0) && (
                                                <>
                                                {/* as={Link} to={`viewdetails`} state={{ sampleType, type,  id } } */}
                                                    <Dropdown.Item  as={Link} to={`/requestor/request-new-sample`} state={{id} }  >
                                                        <label >{'Edit'}</label>
                                                    </Dropdown.Item> </>
                                            )}
                                            {/* && sampleType.status !== 5 */}
                                            {(type == 'requestor') && (
                                                <>
                                                    <Dropdown.Item onClick={()=> handleDuplicateRequest(sampleType.id )}  >
                                                        <label >{'Duplicate'}</label>
                                                    </Dropdown.Item> </>
                                            )}
                                        </>
                                    )}

                                    {(type == 'requestor' && sampleType.status == 0) && (
                                        <>
                                            <Dropdown.Item  onClick={handleShowDeleteModal}>
                                                <label >{'Delete'}</label>
                                            </Dropdown.Item> </>
                                    )}
                                    {/* {
                                        //  (sampleType.status != 8  || sampleType.status != 9 || sampleType.status != 5 ) 
                                        (sampleType.status != 7  || sampleType.status != 8 || sampleType.status != 4 || sampleType.status != 0) 
                                        && (<Dropdown.Item onClick={handleShowDeactivateModal}>
                                                <label className={`text-danger`}>{'Cancel Request'}</label>
                                            </Dropdown.Item>) } */}
                                    {![7, 8, 4, 0].includes(sampleType.status) && (
                                        <Dropdown.Item onClick={handleShowDeactivateModal}>
                                            <label className="text-danger">{'Cancel Request'}</label>
                                        </Dropdown.Item>
                                    )}
                                    
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td>
            </tr>
            </>
          )}
            {/* cancel sample request  */}

             
            <CancellationNoteModal 
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmCancelRequest}
                title="Cancel Request"
            />
            {/* Delete sample request  */}
            <ConfirmationModal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onConfirm={confirmDeleteUser}
                title=""
                body={`Are you sure you want to delete?`}
              
            />

            {showPickupModal && (<>
               {/* Delete sample request  */}
                    <PickupDetailsModal
                        show={showPickupModal}
                        onHide={handleClosePickupModal}
                        onConfirm={confirmPickupModal}  
                        request_id = {sampleType.id}
                        duration={sampleType.sample_collect_duration}
                        sample_count={sampleType.sample_ids?.split(',').map(id => parseInt(id.trim())).length} 
                        status ={sampleType.status}
                        sample={sampleType}
                    />
            </>)}
        </>
    );
}
export default SampleTypeTableRow;